import React, { createContext, ReactType } from 'react';
import { createGlobalStyle } from 'styled-components';

export interface ThemeProps {
  colors: {
    paper: string,
    contrast: string,
    primary: string,
    secondary: string
  },
  spacing: number
}

const getScale = (width: number) => {
  if (width < 560) {
    return 4;
  }

  if (width >= 560 && width < 730) {
    return 8;
  }

  if (width >= 730 && width < 1024) {
    return 10;
  }

  if (width >= 1024 && width < 1600) {
    return 12;
  }

  if (width > 1600) {
    return 14;
  }
}

const themeData = {
  colors: {
    paper: '#0f0f0f',
    contrast: '#474747',
    primary: '#f6ae47',
    secondary: '#b3313f',
    brand: '#e0e0d0'
  },
  spacing: 12,
  media: {
    lg: 1600,
    md: 1024,
    sm: 730,
    xs: 560
  },
  utilArea: 1280,
  board: {
    borderRadius: 2,
    border: 0.6 * (getScale(window.innerWidth) || 14),
    side: 0 * (getScale(window.innerWidth) || 14),
    yMargin: 1.35 * (getScale(window.innerWidth) || 14)
  },
  scale: getScale(window.innerWidth),
  dotsScale: (height: number, scale: number) => {
    const values: any = {
      4: {
        25: 4,
        33: 7.8,
        40: 4.85
      },
      8: {
        25: 8.3,
        33: 9.8,
        40: 9.9
      },
      10: {
        25: 10.3,
        33: 11.8,
        40: 11.9
      },
      12: {
        25: 12.3,
        33: 13.8,
        40: 13.9
      },
      14: {
        25: 14.3,
        33: 15.8,
        40: 15.9
      }
    };
    return values[scale][height] || values[14][25];
  }
};

const Theme = createContext(themeData);

const withTheme = (Component: ReactType) => {
  class ThemeComponent extends React.Component<any> {
    render() {
      return (
        <Theme.Consumer>
          {
            theme => <Component {...this.props} theme={theme}>
              {this.props.children}
            </Component>
          }
        </Theme.Consumer>
      )
    }
  }
  return ThemeComponent;
}

export const GlobalStyle = withTheme(createGlobalStyle`
  * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      font-family: 'Montserrat', sans-serif !important;
  }
  html, body {
    background: ${({ theme }: any) => theme.colors.paper};
    overscroll-behavior: none;
    color: ${({ theme }: any) => theme.colors.contrast};

    .MuiAutocomplete-popper {
      z-index: 99999999;
    }
  }
`);

export default withTheme;